var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{class:_vm.$style.footer},[_c('div',[_c('p',{class:_vm.$style.text},[_vm._v("祈愿：平等大爱 万物祥和 邦国敦睦 天下太平")]),_vm._v(" "),_c('p',{class:_vm.$style.text},[_vm._v("愿消六意诸烦恼 愿得无上般若智 普愿摧毁地狱间 世世广行菩萨道")]),_vm._v(" "),_c('p',{class:_vm.$style.text},[_vm._v("万里虹十方版权所有 欢迎传播 不得用于商业用途")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a71f706","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheFooter/TheFooter.vue
// module id = null
// module chunks = 